'use client'
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react'

export default function DatadogInit() {
    useEffect(() => {
        if (datadogRum.getInitConfiguration()) return

        datadogRum.init({
            applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
            clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
            site: 'datadoghq.com',
            service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
            env: process.env.NEXT_PUBLIC_DATADOG_ENV,
            version: '1.0.0',
            sessionSampleRate: 20,
            sessionReplaySampleRate: 0,
            trackBfcacheViews: true,
            defaultPrivacyLevel: 'mask-user-input',
        });

        datadogRum.startSessionReplayRecording()

    }, [])

    return null
}